import { Modal, useModal } from '../modals';
import { TApiaButtonType } from '../types';
import { ReactNode, Ref, useCallback, useRef } from 'react';
import { Confirm } from '../modals/layout/Confirm';

export interface IConfirm {
  additionalButtons?: ReactNode;
  additionalButtonsOnRight?: ReactNode;
  cancelButtonText?: string;
  children: ReactNode;
  className?: string;
  confirmButtonText?: string;
  confirmButtonVariant?: TApiaButtonType;
  contentRef?: Ref<HTMLDivElement>;
  disabled?: boolean;
  hideCancelButton?: boolean;
  hideConfirmButton?: boolean;
  isLoading?: boolean;
  onConfirm?: () => unknown;
  onCancel?: () => unknown;
  title?: string;
  variant?: string;
}

export const ConfirmModal = ({
  onConfirm,
  onCancel,
  title,
  ...props
}: IConfirm): JSX.Element => {
  const hasConfirmed = useRef(false);

  const { hide, ...modalProps } = useModal({
    isDefaultOpen: true,
    onExited: () => {
      if (hasConfirmed.current) onConfirm?.();
      else onCancel?.();
    },
  });

  const handleCancel = useCallback(() => {
    hide();
  }, [hide]);

  const handleConfirm = useCallback(() => {
    hasConfirmed.current = true;
    hide();
  }, [hide]);

  return (
    <Modal
      {...modalProps}
      initialFocusGetter={useCallback(
        (current: HTMLElement) =>
          current.querySelector<HTMLElement>('.confirm__confirmButton'),
        [],
      )}
      title={title}
    >
      <Confirm {...props} onCancel={handleCancel} onConfirm={handleConfirm} />
    </Modal>
  );
};
